import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';
import getSocketMiddlewareInstance from '../../common/SocketMiddleware';

const apiCaller = getApiInstance();

function getSDM18MVRs() {
    return dispatch => {
        return apiCaller
            .call(api.getAllSDM18MVRs())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'MYFHE__FHEPRODUCT_SET_SDM18MVRS',
                        SDM18MVRs: data.SDM18MVRs
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setMyFHESDM18MVRs - ', error);
                throw error;
            });
    };
}
function getSDM18MVRDetails(SDM18MVRId) {
    return dispatch => {
        return apiCaller
            .call(api.getSDM18MVRDetails(SDM18MVRId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'MYFHE__FHEPRODUCT_SET_SDM18MVR_DETAILS',
                        SDM18MVRId: data.SDM18MVRDetails.macAddress,
                        SDM18MVRDetails: data.SDM18MVRDetails
                    });
                }

                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setMyFHESDM18MVRDetails - ', error);
                throw error;
            });
    };
}
function refreshSDM18MVRStatus(SDM18MVRMac) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductCheckStatus('SDM18MVR', SDM18MVRMac)
            .catch(error => {
                Logger.log('dataActions: refreshMyFHESDM18MVRStatus - ', error);
                throw error;
            });
    };
}
function dissociateSDM18MVRUser(SDM18MVRMac, userId) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductDissociateUser('SDM18MVR', SDM18MVRMac, userId)
            .catch(error => {
                Logger.log('dataActions: dissociateSDM18MVRUser - ', error);
                throw error;
            });
    };
}
function dissociateSDM18MVRUserAndSwitchMaster(SDM18MVRMac, userId, masterId) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductDissociateUserAndSwitchMaster('SDM18MVR', SDM18MVRMac, userId, masterId)
            .catch(error => {
                Logger.log('dataActions: dissociateSDM18MVRUserAndSwitchMaster - ', error);
                throw error;
            });
    };
}
function switchSDM18MVRMaster(SDM18MVRMac, userId) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductMasterSwitch('SDM18MVR', SDM18MVRMac, userId)
            .catch(error => {
                Logger.log('dataActions: switchMyFHESDM18MVRMaster - ', error);
                throw error;
            });
    };
}

export {
    getSDM18MVRs,
    getSDM18MVRDetails,
    refreshSDM18MVRStatus,
    dissociateSDM18MVRUser,
    dissociateSDM18MVRUserAndSwitchMaster,
    switchSDM18MVRMaster
};



// WEBPACK FOOTER //
// ./environments/myfhe/data/SDM18MVR/actions.js